<template>
	<div class="tab-pane fade" id="connections-tab-pane" role="tabpanel" aria-labelledby="connections-tab" tabindex="0">
		<h3>계정연결</h3>
		<hr />

		<div class="row justify-content-center mb-1">
			<div class="col-lg-6">
				<h5 class="text-uppercase mt-3 pb-1">네이버광고 연결</h5>

				<div v-if="adCustomer">
					<h6 class="mt-4">축하합니다. 네이버광고 연결을 성공했습니다.</h6>
				</div>
				<div v-else>
					<p>네이버 검색광고API 정보를 입력해주세요.</p>
					<div class="form-floating mb-3">
						<input type="text" autocomplete="off" class="bgc-fff form-control" ref="customerId" v-model="customerId" placeholder="CUSTOMER_ID" />
						<label>CUSTOMER_ID</label>
					</div>
					<div class="form-floating mb-3">
						<input type="text" autocomplete="off" class="bgc-fff form-control" ref="accessLicense" v-model="accessLicense" placeholder="엑세스라이선스" />
						<label>엑세스라이선스</label>
					</div>
					<div class="form-floating">
						<input type="password" autocomplete="off" class="bgc-fff form-control" ref="secretKey" v-model="secretKey" placeholder="비밀키" />
						<label>비밀키</label>
					</div>
					<div class="d-flex flex-row-reverse">
						<button style="margin-top: 20px;" v-on:click="saveAdCustomer" class="btn btn-outline-primary">연결하기</button>
					</div>
				</div>
			</div>
			<div class="col-lg-6 pt-3">
				<iframe
					v-if="adCustomer == ''"
					style="width: 100%;height: 100%;"
					src="https://www.youtube.com/embed/45r1J6XcZbs"
					title="YouTube video player"
					frameborder="0"
					allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
					allowfullscreen
				></iframe>
				<div v-else class="row">
					<div class="col-lg-6 mb-4">
						<div class="card ">
							<div class="card-header py-3">
								<h5 class="card-title m-0">
									<img src="/images/naverad/ns.png" alt="..." class="img-thumbnail  nlogo-image" />
									<span class="p-2 align-middle">{{ adCustomer.customerId }}</span>
								</h5>
							</div>
							<div class="card-body">
								<p class="card-text">비즈머니 : {{ adCustomer.bizmoneyWithComma }}원</p>
								<p class="card-text">등록일 : {{ adCustomer.updateFormatDate }}</p>
								<button v-on:click="removeAdCustomer" type="button" class="btn btn-link fr">연결해제</button>
								<!-- <button v-on:click="nickname" :aid="adCustomer.searchAdId"  type="button" class="btn btn-link fr">별명</button> -->
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<hr />
		<div class="row justify-content-center mb-1">
			<div class="col-lg-6">
				<h5 class="text-uppercase mt-3 pb-1">스마트스토어 연결</h5>

				<div v-if="channels.length != 0">
					<h6 class="mt-4">축하합니다. 스마트스토어 연결을 성공했습니다.</h6>
					<p class="text-muted">더 많은 스마트스토어를 연결하시겠습니까?</p>
					<button class="btn btn-primary md-5" type="button" data-bs-toggle="collapse" data-bs-target="#collapseCommerce" aria-expanded="false" aria-controls="collapseCommerce">연결 추가하기</button>

					<div class="collapse mt-3" id="collapseCommerce">
						<p>네이버 커머스API 정보를 입력해주세요.</p>
						<div class="form-floating mb-3">
							<input type="text" autocomplete="off" class="bgc-fff form-control" ref="appId" v-model="appId" placeholder="애플리케이션 ID" />
							<label>애플리케이션 ID</label>
						</div>
						<div class="form-floating">
							<input type="password" autocomplete="off" class="bgc-fff form-control" ref="appSecret" v-model="appSecret" placeholder="애플리케이션 시크릿" />
							<label>애플리케이션 시크릿</label>
						</div>
						<div class="d-flex flex-row-reverse">
							<button style="margin-top: 20px;" v-on:click="saveCommerceApiInfo" class="btn btn-outline-primary">연결하기</button>
						</div>
					</div>
				</div>
				<div v-else>
					<p>네이버 커머스API 정보를 입력해주세요.</p>
					<div class="form-floating mb-3">
						<input type="text" autocomplete="off" class="bgc-fff form-control" ref="appId" v-model="appId" placeholder="애플리케이션 ID" />
						<label>애플리케이션 ID</label>
					</div>
					<div class="form-floating">
						<input type="password" autocomplete="off" class="bgc-fff form-control" ref="appSecret" v-model="appSecret" placeholder="애플리케이션 시크릿" />
						<label>애플리케이션 시크릿</label>
					</div>
					<div class="d-flex flex-row-reverse">
						<button style="margin-top: 20px;" v-on:click="saveCommerceApiInfo" class="btn btn-outline-primary">연결하기</button>
					</div>
				</div>
			</div>
			<div class="col-lg-6 pt-3">
				<iframe
					v-if="channels.length == 0"
					style="width: 100%;height: 100%;"
					src="https://www.youtube.com/embed/45r1J6XcZbs"
					title="YouTube video player"
					frameborder="0"
					allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
					allowfullscreen
				></iframe>
				<div v-else class="row">
					<div class="col-lg-6 mb-4" v-for="channel in channels" :key="channel.channelNo">
						<div class="card ">
							<div class="card-header py-3">
								<h5 class="card-title m-0">
									<img src="/images/naverad/ns.png" alt="..." class="img-thumbnail  nlogo-image" />
									<span class="p-2 align-middle">{{ channel.channelName }}</span>
								</h5>
							</div>
							<div class="card-body">
								<div v-if="channel.channelUrl == null" class="card-text">
									<div class="fw-bold mb-1">비즈채널 등록이 필요합니다.</div>
									<div class="text-danger mb-3">- 네이버광고 > 광고시스템 > <br />정보관리 > 비즈채널관리 > 채널 추가</div>
								</div>
								<p v-else class="card-text">등록일 : {{ channel.updateFormatDate }}</p>
								<button v-on:click="removeCommerceApi" :cNo="channel.channelNo" type="button" class="btn btn-link fr">연결해제</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Swal from "../../../../js/sweetalert2.min.js";
import axios from "axios";
import $ from "jquery";

export default {
	data() {
		return {
			channels: [],
			appId: "",
			appSecret: "",
			adCustomer: "",
			customerId: "",
			accessLicense: "",
			secretKey: ""
		};
	},
	beforeMount() {
		// this.getAdCustomer();
		// this.getChannels();
	},
	mounted() {},
	methods: {
		invalidSession(error) {
			Swal.close();
			if (error && error.response && error.response.status && error.response.status == 401) {
				swal("세션이 만료되었습니다. 다시 로그인 해주세요.").then(() => {
					this.$router.push("/signin");
				});
			} else {
				swal("네트워크에 접속할 수 없습니다.", "네트워크 연결 상태를 확인해주세요.", { icon: "info" });
			}
		},
		serverError() {
			Swal.close();
			swal("잠시 후 다시 시도해주세요.", "지속적으로 발생할 경우 우측하단 채널톡으로 문의주세요.", { icon: "info" });
		},
		async getAdCustomer() {
			this.spinnerStart();
			const response = await axios.get("/ad/getAdCustomer");
			this.spinnerEnd();
			if (response.status != 200 || !response.data) {
				swal("마이파랑 서버에 연결할 수 없습니다.", "일시적인 장애이거나 네트워크 문제일 수 있습니다.\n 잠시 후 다시 이용해주세요. \n 계속 발생하는 경우 우측하단 채널톡 통해\n 문의해주세요.", { icon: "info" });

				return;
			}
			let code = response.data.code;
			if (code == 1) {
				let adCustomer = response.data.adCustomer;
				adCustomer.updateFormatDate = this.dateformat(new Date(adCustomer.updateDate));
				adCustomer.bizmoneyWithComma = this.numberWithCommas(adCustomer.bizmoney);
				this.adCustomer = adCustomer;
				this.customerId = "";
				this.accessLicense = "";
				this.secretKey = "";
			} else if (code == 0) {
				this.adCustomer = "";
			}
		},

		async saveAdCustomer() {
			if (this.customerId == "") {
				swal("customerId를 입력해주세요.").then(value => {
					this.$refs.customerId.focus();
				});
				return;
			} else if (this.accessLicense == "") {
				swal("엑세스라이선스를 입력해주세요.").then(value => {
					this.$refs.accessLicense.focus();
				});
				return;
			} else if (this.secretKey == "") {
				swal("비밀키를 입력해주세요.").then(value => {
					this.$refs.secretKey.focus();
				});
				return;
			}

			let form = new FormData();
			form.append("customerId", this.customerId);
			form.append("accessLicense", this.accessLicense);
			form.append("secretKey", this.secretKey);
			this.spinnerStart();
			const response = await axios.post("/ad/saveAdCustomer", form);
			this.spinnerEnd();
			if (response.status != 200 || !response.data) {
				swal("마이파랑 서버에 연결할 수 없습니다.", "일시적인 장애이거나 네트워크 문제일 수 있습니다.\n 잠시 후 다시 이용해주세요. \n 계속 발생하는 경우 우측하단 채널톡 통해\n 문의해주세요.", { icon: "info" });
				return;
			}

			let code = response.data.code;

			switch (code) {
				case -1:
					swal("광고API 연결에 실패했습니다.\n일시적인 장애이거나 네트워크 문제일 수 있습니다.\n 잠시 후 다시 이용해주세요.");
					break;
				case 0:
					swal("입력값이 존재하지 않습니다. 입력값을 정확하게 확인해주세요.");
					break;
				case 1:
					swal("네이버 검색광고를 연결했습니다.");
					let adCustomer = response.data.adCustomer;
					adCustomer.updateFormatDate = this.dateformat(new Date(adCustomer.updateDate));
					adCustomer.bizmoneyWithComma = this.numberWithCommas(adCustomer.bizmoney);
					this.adCustomer = adCustomer;
					this.customerId = "";
					this.accessLicense = "";
					this.secretKey = "";
					break;
				case 2:
					swal("이미 연결했습니다.");
					break;
				case 4:
					swal("입력값이 유효하지 않습니다. 입력값을 정확하게 확인해주세요.");
					break;
				default:
					swal("광고API 연결에 실패했습니다.\n일시적인 장애이거나 네트워크 문제일 수 있습니다.\n 잠시 후 다시 이용해주세요.");
					break;
			}
		},
		async removeAdCustomer() {
			swal("네이버 검색광고 연결을 해제하시겠습니까?", {
				buttons: {
					yes: "예. 연결을 해제하겠습니다.",
					no: "아니요."
				}
			}).then(async value => {
				if (value == "yes") {
					let form = new FormData();
					form.append("customerId", this.adCustomer.customerId);
					this.spinnerStart();
					const response = await axios.post("/ad/removeAdCustomer", form);
					this.spinnerEnd();
					if (response.status != 200 || !response.data) {
						swal("마이파랑 서버에 연결할 수 없습니다.", "일시적인 장애이거나 네트워크 문제일 수 있습니다.\n 잠시 후 다시 이용해주세요. \n 계속 발생하는 경우 우측하단 채널톡 통해\n 문의해주세요.", { icon: "info" });
						return;
					}

					let code = response.data.code;
					switch (code) {
						case 1:
							swal("네이버광고 연결을 해제했습니다.");
							this.adCustomer = "";
							break;
						case 0:
							swal("이미 연결 해제한 스토어입니다.");
							break;
						default:
							swal("스토어 연결 해제에 실패했습니다.");
							break;
					}
				}
			});
		},
		async getChannels() {
			this.spinnerStart();
			const response = await axios.get("/commerce/getChannels");
			this.spinnerEnd();
			if (response.status != 200 || !response.data) {
				swal("마이파랑 서버에 연결할 수 없습니다.", "일시적인 장애이거나 네트워크 문제일 수 있습니다.\n 잠시 후 다시 이용해주세요. \n 계속 발생하는 경우 우측하단 채널톡 통해\n 문의해주세요.", { icon: "info" });

				return;
			}
			let code = response.data.code;
			if (code == 1) {
				this.channels = response.data.channels;
				for (let channel of response.data.channels) {
					channel.updateFormatDate = this.dateformat(new Date(channel.updateDate));
				}
			} else if (code == 0) {
				this.channels = [];
			}
		},
		async saveCommerceApiInfo() {
			this.errors = [];
			if (!this.appId || this.appId.trim() == "") {
				this.errors.push("애플리케이션 ID를 입력해주세요.");
			}
			if (!this.appSecret || this.appSecret.trim() == "") {
				this.errors.push("애플리케이션 시크릿을 입력해주세요.");
			}
			if (this.errors.length > 0) {
				swal(this.errors[0]);
				return true;
			}

			let form = new FormData();
			form.append("appId", this.appId);
			form.append("appSecret", this.appSecret);
			this.spinnerStart();
			const response = await axios.post("/commerce/saveApi", form);
			this.spinnerEnd();

			if (response.status != 200 || !response.data) {
				swal("마이파랑 서버에 연결할 수 없습니다.", "일시적인 장애이거나 네트워크 문제일 수 있습니다.\n 잠시 후 다시 이용해주세요. \n 계속 발생하는 경우 우측하단 채널톡 통해\n 문의해주세요.", { icon: "info" });

				return;
			}

			let code = response.data.code;

			switch (code) {
				case 0:
					swal("애플리케이션 ID 또는 시크릿 값이 정확하게 입력되지 않았습니다.");
					break;
				case 1:
					swal("스토어를 연결했습니다.");
					this.appId = "";
					this.appSecret = "";
					let channel = response.data.channel;
					channel.updateFormatDate = this.dateformat(new Date(channel.updateDate));
					this.channels.push(channel);
					break;
				case 2:
					swal("이미 연결한 스토어입니다.");
					break;
				default:
					swal("스토어 연결에 실패했습니다.\n애플리케이션 ID와 시크릿을 확인해주세요.");
					break;
			}
		},
		async removeCommerceApi(e) {
			swal("스마트스토어 연결을 해제하시겠습니까?", {
				buttons: {
					yes: "예. 연결을 해제하겠습니다.",
					no: "아니요."
				}
			}).then(async value => {
				if (value == "yes") {
					let cNo = e.target.getAttribute("cNo");
					let form = new FormData();
					form.append("channelNo", cNo);
					this.spinnerStart();
					const response = await axios.post("/commerce/removeApi", form);
					this.spinnerEnd();
					if (response.status != 200 || !response.data) {
						swal("마이파랑 서버에 연결할 수 없습니다.", "일시적인 장애이거나 네트워크 문제일 수 있습니다.\n 잠시 후 다시 이용해주세요. \n 계속 발생하는 경우 우측하단 채널톡 통해\n 문의해주세요.", { icon: "info" });
						return;
					}

					for (var i = 0; i < this.channels.length; i++) {
						let channelNo = this.channels[i].channelNo;
						if (cNo == channelNo) {
							this.channels.splice(i, 1);
							break;
						}
					}
					let code = response.data.code;
					switch (code) {
						case 1:
							swal("스토어 연결을 해제했습니다.");
							break;
						case 0:
							swal("이미 연결 해제한 스토어입니다.");
							break;
						default:
							swal("스토어 연결 해제에 실패했습니다.");
							break;
					}
				}
			});
		},

		dateformat(current_datetime) {
			var month = current_datetime.getMonth() + 1;
			if (month < 10) {
				month = "0" + month;
			}
			var day = current_datetime.getDate();
			if (day < 10) {
				day = "0" + day;
			}
			let formatted_date = current_datetime.getFullYear() + "년 " + month + "월 " + day + "일";
			return formatted_date;
		},
		numberWithCommas(x) {
			return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
		},
		spinnerStart() {
			let preloader = document.getElementById("preloader");
			if (preloader) {
				preloader.style.visibility = "visible";
				preloader.style.opacity = "0.5";
				preloader.style.background = "#000";
			}
		},
		spinnerEnd: function() {
			let preloader = document.getElementById("preloader");
			if (preloader) {
				preloader.style.visibility = "hidden";
				preloader.style.opacity = "0";
			}
		}
	}
};
</script>
<style>
.fr {
	float: right;
	padding: 0;
}
.nlogo-image {
	width: 30px;
	border: 0px;
	padding: 0;
}
.strategy {
	cursor: pointer;
}
.strategy.selected {
	border: 2px solid #3153fa;
}
.min-height770 {
	min-height: 770px;
}
.pointer {
	cursor: pointer;
}
.addedProducts {
	overflow-y: auto;
	max-height: 680px;
}
.w-2 {
	width: 2%;
}
.w-5 {
	width: 5%;
}
.w-6 {
	width: 6%;
}
.w-7 {
	width: 7%;
}
.w-8 {
	width: 8%;
}
.w-10 {
	width: 10%;
}
.w-55 {
	width: 55%;
}
.w-60 {
	width: 60%;
}
.w-65 {
	width: 65%;
}
.w-80 {
	width: 80%;
}

.ad-table thead {
	display: inline-block;
	width: 100%;
}
.ad-table tbody {
	display: inline-block;
	width: 100%;
}
.ad-table tbody {
	max-height: 400px;
	overflow-y: auto;
}
.ad-table thead tr {
	display: inline-table;
	width: 100%;
}
.ad-table tbody tr {
	display: inline-table;
	width: 100%;
}

.exclamationmark {
	width: 16px;
	height: 16px;
}

.switch {
	position: relative;
	display: inline-block;
	width: 54px;
	height: 30px;
}

.switch input {
	display: none;
}

td .slider {
	position: absolute;
	cursor: pointer;
	top: 2px;
	left: 0;
	right: 0;
	bottom: -4px;
	background-color: #ccc;
	-webkit-transition: 0.4s;
	transition: 0.4s;
}

td .slider:before {
	position: absolute;
	content: "";
	height: 22px;
	width: 22px;
	left: 3px;
	bottom: 5px;
	background-color: white;
	-webkit-transition: 0.4s;
	transition: 0.4s;
}

input + .slider {
	background-color: #ccc;
	text-align: right;
	padding: 7px 6px;
	font-size: 12px;
	color: #fff;
}

input:checked + .slider {
	background-color: #3153fa;
	text-align: left;
}

input:focus + .slider {
	box-shadow: 0 0 1px #3153fa;
}

input:checked + .slider:before {
	-webkit-transform: translateX(26px);
	-ms-transform: translateX(26px);
	transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
	border-radius: 34px;
}

.slider.round:before {
	border-radius: 50%;
}

.slot {
	background-color: #aaa;
	padding: 0.5rem;
	color: white;
	display: flex;
	align-items: center;
	justify-content: space-between;
}

.text-black {
	color: #000;
}
</style>



// WEBPACK FOOTER //
// src/components/main/naverad/Api.vue